import { render } from "./filter_wrapper.vue?vue&type=template&id=bae4c014"
import script from "./filter_wrapper.vue?vue&type=script&lang=js"
export * from "./filter_wrapper.vue?vue&type=script&lang=js"

import "./filter_wrapper.vue?vue&type=style&index=0&id=bae4c014&lang=less"

import exportComponent from "/home/runner/work/suplasercut-admin/suplasercut-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__